import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const TextToolTipContent = ({ label, isBottom, content }) => {
    return (
        <>
            <OverlayTrigger placement={isBottom ? "bottom" : "top"} overlay={<Popover className='imageUploadTooltipContainer'>{label}</Popover>}>
                <span>{content}</span>
            </OverlayTrigger>
        </>
    )
}

export default TextToolTipContent;
